import * as actionTypes from "./actionTypes";
import { keyBy } from "lodash";


export function getStoredPDFStatistics(payload) {
  return { type: actionTypes.GET_PDF_STATISTICS, payload };
}

export function getStoredPDFStatisticsSuccess(payload) {
  return { type: actionTypes.GET_PDF_STATISTICS_SUCCESS, payload };
}

export function removeQueue(payload) {
  return { type: actionTypes.REMOVE_QUEUE, payload };
}

export function removeQueueSuccess(payload) {
  return { type: actionTypes.REMOVE_QUEUE_SUCCESS, payload };
}

